import { Injectable, Signal, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointName, breakpoints } from '@fc-core/constants/breakpoints';
import { fromEvent } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BreakpointsService {
  readonly viewportWidth = toSignal(
    fromEvent(window, 'resize').pipe(
      startWith(null),
      map(() => window.innerWidth),
    ),
    { initialValue: window.innerWidth },
  );
  readonly isMobile = computed(() => !this.currentResolution('sm'));
  readonly isTablet = computed(
    () => !this.isMobile() && !this.currentResolution('xl'),
  );
  readonly isDesktop = this.currentResolutionSignal('xl');

  currentResolution(breakpoint: BreakpointName): boolean {
    return this.viewportWidth() >= breakpoints[breakpoint];
  }

  currentResolutionSignal(breakpoint: BreakpointName): Signal<boolean> {
    return computed(() => this.currentResolution(breakpoint));
  }
}
